// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

const RETURN_TO_KEY = "riddle.auth.returnTo";

function isSafeReturnTo(value: string | null): value is string {
  if (
    value === null ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    value.includes("\\") ||
    value === "/" ||
    value.startsWith("/?")
  ) {
    return false;
  }
  try {
    return new URL(value, window.location.origin).origin === window.location.origin;
  } catch {
    return false;
  }
}

export function rememberReturnTo(url: string): void {
  if (!isSafeReturnTo(url)) {
    return;
  }
  try {
    window.sessionStorage.setItem(RETURN_TO_KEY, url);
  } catch {
  }
}

export function consumeReturnTo(): string | null {
  try {
    const value = window.sessionStorage.getItem(RETURN_TO_KEY);
    window.sessionStorage.removeItem(RETURN_TO_KEY);
    return isSafeReturnTo(value) ? value : null;
  } catch {
    return null;
  }
}
